import clsx from 'clsx';
import styles from './Heading.module.scss';

type HeadingLevels = 1 | 2 | 3 | 4 | 5 | 6;
export type HeadingFont = 'default' | 'brand';

interface HeadingProps {
  level: HeadingLevels;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl';
  children: React.ReactNode;
  font?: HeadingFont;
  id?: string;
  className?: string;
}

export const Heading = ({
  level,
  size = 'md',
  children,
  font = 'default',
  id,
  className,
}: HeadingProps) => {
  const Tag = `h${level}` as keyof React.JSX.IntrinsicElements;

  const headingClass = clsx(styles.heading, {
    [styles[`size-${size}`]]: size,
  });

  return (
    <Tag
      className={clsx(headingClass, className, {
        [styles.fontBrand]: font === 'brand',
      })}
      id={id}
    >
      {children}
    </Tag>
  );
};

interface HeadingHighlightProps {
  children: React.ReactNode;
}

export const HeadingHighlight: React.FC<HeadingHighlightProps> = ({ children }) => (
  <em className={styles.highlight}>{children}</em>
);
